export class ValidateEmailRequest {
    public idHealthUnit: number;

    public userEmail: string;
}